import TargetLink from "@/components/TargetLink";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import styles from "@/styles/Row.module.scss";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AdvertListRow(_ref) {
  var item = _ref.item;
  var target = useMemo(function () {
    if (item.targetBlank) {
      return "_blank";
    } else {
      return "_self";
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, styles.list),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.artwork,
        children: /*#__PURE__*/_jsx(CardArtwork, {
          item: item,
          className: styles.artworkInner,
          href: item.url,
          linkAttr: {
            target: target,
            rel: "noopener noreferrer"
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(TargetLink, {
            href: item.url,
            blank: item.targetBlank,
            children: item.name
          })
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: item.description
        })]
      })]
    })
  });
}